import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import config from '../../config.json';
import { theme } from '../../styles';
import { List, Main, MainContent, SideNav, NavText, Title } from '../../components';
import { AcceptableWrapper, AcceptableItem } from './style';
import { ContractIcon, BoardIcon } from '../../assets/svg';

const TermsContent = (
  <>
    <Title key='terms-title'>Terms of Service</Title>
    <List
      key='term-list'
      items={config.terms}
    />
    <AcceptableWrapper
      initial={theme.fadeIn.initial}
      animate={theme.fadeIn.animate}
      transition={theme.fadeIn.transition(theme.delaySm + 0.1 * config.terms.length)}
    >
      <AcceptableItem $acceptable>
        <h3>Will Do</h3>
        <p>{config.willDo.join(', ')}</p>
      </AcceptableItem>
      <AcceptableItem>
        <h3>Won't Do</h3>
        <p>{config.wontDo.join(', ')}</p>
      </AcceptableItem>
    </AcceptableWrapper>
  </>
);

const WorkContent = (
  <>
    <Title key='work-title'>Work Process</Title>
    <List
      key='work-list'
      items={config.workProcess}
    />
  </>
);

const Terms = () => {
  const location = useLocation();
  const [active, setActive] = useState(location.state?.work ? 'Work Process' : 'Terms');

  return (
    <Main
      $flexDirection='row'
      animate={theme.fadeIn.animate}
      exit={theme.fadeIn.initial}
      transition={theme.fadeIn.transition(0)}
    >
      <SideNav
        active={active}
        items={{
          Terms: {
            element: (
              <>
                <ContractIcon />
                <NavText>Terms</NavText>
              </>
            ),
          },
          'Work Process': {
            element: (
              <>
                <BoardIcon />
                <NavText>Work Process</NavText>
              </>
            ),
          },
        }}
        handleSelect={select => setActive(select)}
      />
      <MainContent
        initial={theme.fadeIn.initial}
        animate={theme.fadeIn.animate}
        transition={theme.fadeIn.transition(theme.delaySm)}
      >
        {active === 'Terms' ? TermsContent : WorkContent}
      </MainContent>
    </Main>
  );
};

export default Terms;
